// Module
var code = "<div id=\"V-F987A10C-1330-4725-A966-9652386E6228\"> <table style=\"width:100%;height:100%\"> <thead> <th>1</th> <th>2</th> <th>3</th> </thead> <tbody> <tr data-b-itemsSource=\"{Binding tds}\"> </tr> </tbody> </table> </div> ";
// Exports
export default code;